import { createTheme } from '@mui/material/styles'

/**
 * Applies button color override from store settings to the theme.
 * Creates a custom palette color and sets it as the default button color.
 * Uses MUI's augmentColor to auto-generate light, dark, and contrastText.
 *
 * @param {import('@mui/material/styles').Theme} theme - The base MUI theme
 * @param {Object|null} storeSettings - Store customization settings
 * @returns {Object} Modified theme options object
 */
export const applyButtonOverrides = (theme, storeSettings) => {
    const buttonColour = storeSettings?.webStoreButtonColour
    if (!buttonColour) {
        return theme
    }

    const tempTheme = createTheme()
    const augmented = tempTheme.palette.augmentColor({
        color: { main: buttonColour },
        name: 'buttonCustom',
    })

    return {
        ...theme,
        palette: {
            ...theme.palette,
            buttonCustom: augmented,
        },
        components: {
            ...theme.components,
            MuiButton: {
                ...theme.components?.MuiButton,
                defaultProps: {
                    ...theme.components?.MuiButton?.defaultProps,
                    color: 'buttonCustom',
                    disableElevation: true,
                },
                styleOverrides: {
                    ...theme.components?.MuiButton?.styleOverrides,
                    containedPrimary: {
                        backgroundColor: augmented.main,
                        color: augmented.contrastText,
                        '&:hover': {
                            backgroundColor: augmented.dark,
                        },
                    },
                    outlinedPrimary: {
                        color: augmented.main,
                        borderColor: augmented.main,
                        '&:hover': {
                            borderColor: augmented.dark,
                            backgroundColor: `${augmented.main}14`,
                        },
                    },
                    textPrimary: {
                        color: augmented.main,
                        '&:hover': {
                            backgroundColor: `${augmented.main}14`,
                        },
                    },
                },
            },
        },
    }
}
